import { useState } from 'react';
import { ASCENDING } from 'constants/sortDirections';
import { GhostButton } from 'ui/button';
import { LeftTooltip } from 'ui/tooltip';
import {
  ARROW_DIRECTION_DOWN,
  CollapsibleContent,
  CollapsibleContentArrow,
} from 'ui/collapsibleContent';
import { JsonView } from 'ui/treeView';
import { Table } from 'ui/table';
import { TableCell } from 'ui/tableCell';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { isValidEmail } from 'utils/stringHelpers';
import { CellAlignTypes } from 'modules/experiments/types';
import { displayContent } from 'modules/templateEditor/common';
import { UserData, useSendTestMsgContext } from 'modules/templateEditor/context/SendTestMsgContext';

const EMAIL_FIELD = 'email';
const USER_ID_FIELD = 'userId';

const getUserKey = (dataFields: Record<string, unknown>): string => {
  if (EMAIL_FIELD in dataFields) {
    return dataFields.email as string;
  }
  if (USER_ID_FIELD in dataFields) {
    return dataFields.userId as string;
  } else {
    return '';
  }
};

const UserDataRowCell = ({ row }: { row: UserData }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const userKey = getUserKey(row.dataFields);
  return (
    <TableCell>
      <div
        style={{ display: 'flex', justifyContent: 'space-between' }}
        data-test={`user-data-row-${getUserKey(row.dataFields)}${isCollapsed ? '-collapsed' : ''}`}
      >
        {isValidEmail(userKey) ? userKey : `ID: ${userKey}`}
        <LeftTooltip tooltipContent={displayContent.strExpandUserData} isEnabled={isCollapsed}>
          <GhostButton onClick={() => setIsCollapsed(!isCollapsed)}>
            <CollapsibleContentArrow
              isCollapsed={isCollapsed}
              arrowStart={ARROW_DIRECTION_DOWN}
              arrowEnd={180}
              width={16}
              height={16}
            />
          </GhostButton>
        </LeftTooltip>
      </div>
      <CollapsibleContent isCollapsed={isCollapsed}>
        <JsonView src={row.dataFields} showToggle={false} />
      </CollapsibleContent>
    </TableCell>
  );
};

export const UserDataSummaryTable = () => {
  const { sendTestAsRandomUserData } = useSendTestMsgContext();
  const [sortDirection, setSortDirection] = useState(ASCENDING);
  return (
    <Table>
      <TableHeader
        columns={[
          {
            align: CellAlignTypes.flexStart,
            name: displayContent.headerUserData,
            value: 'dataFields',
            sortable: true,
          },
        ]}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        sortedBy={''} // TODO: this should updated later. it was added as a stopgap due to pre-ts logics passing in `undefined`
        setSortedBy={() => null}
      />
      <TableRows
        rows={sendTestAsRandomUserData.map((row) => ({
          ...row,
          id: getUserKey(row.dataFields),
        }))}
        columns={[
          {
            RowCell: UserDataRowCell,
            align: CellAlignTypes.flexStart,
            name: displayContent.headerUserData,
            value: 'dataFields',
            sortable: true,
          },
        ]}
      />
    </Table>
  );
};
